module.exports = __webpack_public_path__ + "img/qr_code_apple_app_store.e475eacf.png";